import { Box, Flex, Text, Button, Heading, Card, Container } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';

const AboutPage = () => {
    const navigate = useNavigate();

    return (
        <Flex
            direction="column"
            align="center"
            gap="9"
            py="9"
            px="4"
            style={{ minHeight: '100vh' }}
        >
            {/* Header Section */}
            <Container size="4">
                <Flex direction="column" gap="4" maxWidth="1080px">
                    <Text size="9" weight="bold" align="center">
                        About Us
                    </Text>
                    <Text size="4" color="gray" align="center">
                        Transforming education through innovative digital learning solutions
                    </Text>
                </Flex>
            </Container>

            {/* Mission Section */}
            <Container size="4">
                <Flex
                    direction={{ initial: 'column', md: 'row' }}
                    width="100%"
                    maxWidth="1080px"
                    gap="6"
                    align="center"
                >
                    <Box style={{ flex: 1 }}>
                        <img
                            src="/images/about.jpg"
                            alt="Team collaborating"
                            style={{
                                width: '100%',
                                minWidth: '300px',
                                maxWidth: '500px',
                                height: 'auto',
                                borderRadius: 'var(--radius-3)',
                                objectFit: 'cover'
                            }}
                        />
                    </Box>
                    <Flex direction="column" gap="4" style={{ flex: 1 }}>
                        <Heading size="6">Our Mission</Heading>
                        <Text size="3">
                            We empower schools, teachers, and parents with an adaptive learning platform that
                            personalizes education, enhances engagement, and creates new opportunities for
                            academic success. Our goal is to make quality education accessible and effective
                            through technology.
                        </Text>
                    </Flex>
                </Flex>
            </Container>

            {/* Values Section */}
            <Container size="4">
                <Flex
                    gap="8"
                    direction={{ initial: 'column', sm: 'row' }}
                    width="100%"
                >
                    <Card style={{ flex: 1 }}>
                        <Heading size="4">Innovation</Heading>
                        <Text size="3">
                            We continuously evolve our platform to meet the changing needs of digital education.
                        </Text>
                    </Card>
                    <Card style={{ flex: 1 }}>
                        <Heading size="4">Accessibility</Heading>
                        <Text size="3">
                            Education should be available to everyone, anytime, on any device.
                        </Text>
                    </Card>
                    <Card style={{ flex: 1 }}>
                        <Heading size="4">Empowerment</Heading>
                        <Text size="3">
                            We provide tools that enable educators and learners to reach their full potential.
                        </Text>
                    </Card>
                </Flex>
            </Container>
        </Flex>
    );
};

export default AboutPage;